import { c as _c } from "react-compiler-runtime";
import { useEffect, useMemo, useState } from 'react';
const TBODY_ELEMENT_TYPE = 'TBODY';
const THEAD_ELEMENT_TYPE = 'THEAD';
const TR_ELEMENT_TYPE = 'TR';
export default function useCommentableAreaStyles(t0) {
  "use memo";

  const $ = _c(8);
  const {
    commentableArea,
    children
  } = t0;
  const [isTableChild, setIsTableChild] = useState(false);
  let t1;
  if ($[0] !== (commentableArea === null || commentableArea === void 0 ? void 0 : commentableArea.parentNode)) {
    t1 = () => {
      if (!((commentableArea === null || commentableArea === void 0 ? void 0 : commentableArea.parentNode) instanceof HTMLElement)) {
        return;
      }
      const parentStyles = getComputedStyle(commentableArea === null || commentableArea === void 0 ? void 0 : commentableArea.parentNode);
      const inlineParentStyles = commentableArea === null || commentableArea === void 0 ? void 0 : commentableArea.parentNode.style;
      setIsTableChild(parentStyles.display === "table" || inlineParentStyles && inlineParentStyles.display === "table" || (commentableArea === null || commentableArea === void 0 ? void 0 : commentableArea.parentNode.nodeName) === TBODY_ELEMENT_TYPE || (commentableArea === null || commentableArea === void 0 ? void 0 : commentableArea.parentNode.nodeName) === THEAD_ELEMENT_TYPE);
    };
    $[0] = commentableArea === null || commentableArea === void 0 ? void 0 : commentableArea.parentNode;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== commentableArea) {
    t2 = [commentableArea, children];
    $[2] = children;
    $[3] = commentableArea;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  bb0: {
    if (commentableArea) {
      t3 = commentableArea.nodeName === TR_ELEMENT_TYPE;
      break bb0;
    }
    t3 = false;
  }
  const isTr = t3;
  let t4;
  if ($[5] !== isTableChild || $[6] !== isTr) {
    t4 = {
      isTableChild,
      isTr
    };
    $[5] = isTableChild;
    $[6] = isTr;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}